import { getHours } from 'date-fns';
import type { BrowsedTripResult } from '../api/models/bff/TripSearch';
import { getTimezoneDate } from '../utils/dateUtils';

export function normalizeTimezone(timezone: string): string {
  return timezone === 'Z' ? 'Europe/Madrid' : timezone;
}

export function getLocalDepartureHour(trip: BrowsedTripResult): number {
  const timezone = normalizeTimezone(trip.departure.date.zoneId);
  const localDate = getTimezoneDate(new Date(trip.departure.date.utc), timezone);
  return getHours(localDate);
}